<template>
  <div>
    <a class="mb-3 d-block" href="#" @click="open">{{ link_text }}</a>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "OtherVendors",
  props: {
    link_text: {
      required: true,
      type: String
    }
  },
  methods: {
    ...mapActions({
      showOtherVendorsModal: "productShow/showOtherVendorsModal"
    }),
    open() {
      this.showOtherVendorsModal(true);
    }
  }
};
</script>
